import { Box, Link, Modal, styled, Tabs, Typography } from '@mui/material';
import UPButton from 'components/button';
import { UPInputLabel } from 'components/input/styles';
import BackgroundMobile from '../../../assets/icons/IntermediaryPageBackground.svg';
import Background from '../../../assets/icons/onboarding/OnboardingBackground.svg';

export const ModalWrapper = styled(Modal)(({ theme }) => ({
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '944px',
  maxHeight: '650px',
  height: '650px',
  '.MuiBackdrop-root': {
    boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.05)',
    borderRadius: '8px',
    position: 'relative',
  },
  [theme.breakpoints.down('lg')]: {
    width: '720px',
  },
  [theme.breakpoints.down(800)]: {
    width: '96%',
  },
}));

export const ModalHeader = styled(Box)(() => ({
  position: 'sticky',
  top: 0,
  background: 'white',
  padding: '32px 32px 0px 32px',
  zIndex: 999,
  borderTopRightRadius: '8px',
  borderTopLeftRadius: '8px',
}));
export const ModalContainer = styled(Box)(() => ({
  width: '100%',
  boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.05)',
  borderRadius: '8px',
  border: 'none',
  height: '500px',
}));

export const ModalTitle = styled(Typography)(({ theme }) => ({
  marginBottom: '16px',
  color: theme.palette.secondary.contrastText,
  fontWeight: 600,
  fontSize: 16,
  textAlign: 'left',
}));

export const ModalFooter = styled(Box)(() => ({
  background: 'white',
  padding: '12px 0px',
  display: 'flex',
  justifyContent: 'center',
  position: 'relative',
  borderBottomRightRadius: '8px',
  borderBottomLeftRadius: '8px',
}));

export const TabsContainer = styled(Tabs)(({ theme }) => ({
  '.MuiTabs-flexContainer': {
    justifyContent: 'center',
  },
  [theme.breakpoints.down(722)]: {
    '.MuiTabs-flexContainer': {
      display: 'none',
    },
  },
}));

export const EmployeeModalInfoContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  marginTop: '34px',
  [theme.breakpoints.down(722)]: {
    display: 'flex',
    flexDirection: 'column',
  },
}));

export const EmployeeModalPasswordContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  marginTop: '10px',
  [theme.breakpoints.down(722)]: {
    display: 'flex',
    flexDirection: 'column',
  },
}));

export const DependentsContainer = styled(Box)(({ theme }) => ({
  marginTop: '0px',
  display: 'flex',

  [theme.breakpoints.down(722)]: {
    display: 'flex',
    flexDirection: 'column',
  },
}));

export const WorkerclassBox = styled(Box)(({ theme }) => ({
  marginRight: '32px',
  width: '32%',

  [theme.breakpoints.down(722)]: {
    marginRight: ' unset',
    marginBottom: '16px',
    width: '100%',
  },
}));

export const DependentsBottomContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  width: '50%',
  [theme.breakpoints.down(722)]: {
    width: '100%',
    flexDirection: 'column',
  },
}));

export const EmployeeInfoSmallBox = styled(Box)(({ theme }) => ({
  marginRight: '16px',
  width: '25%',
  [theme.breakpoints.down(722)]: {
    marginRight: 'unset',
    marginBottom: '16px',
    width: '100%',
  },
}));

export const InactiveBoxStyled = styled(Box)(({ theme }) => ({
  marginLeft: 'auto',
  position: 'absolute',
  right: '5px',
  [theme.breakpoints.down(722)]: {
    display: 'none',
  },
}));

export const AccountSmallBox = styled(Box)(({ theme }) => ({
  width: '33.3%',
  [theme.breakpoints.down(722)]: {
    marginBottom: '16px',
    width: '100%',
  },
}));
export const PostalCodeBox = styled(Box)(({ theme }) => ({
  width: '17%',
  [theme.breakpoints.down(722)]: {
    width: '50%',
  },
}));

export const EmailBox = styled(Box)(({ theme }) => ({
  width: '50%',
  marginRight: '16px',
  [theme.breakpoints.down(722)]: {
    marginRight: 'unset',
    marginBottom: '16px',
    width: '100%',
  },
}));

export const EmployeeBigBox = styled(Box)(({ theme }) => ({
  width: '50%',
  marginRight: '16px',
  [theme.breakpoints.down(722)]: {
    marginRight: 'unset',
    width: '100%',
  },
}));

export const CountryBox = styled(Box)(({ theme }) => ({
  width: '50%',
  marginTop: '24px',
  [theme.breakpoints.down(722)]: {
    width: '100%',
    marginTop: '16px',
  },
}));

export const ContactInfoSmallContainer = styled(Box)(({ theme }) => ({
  marginRight: '16px',
  display: 'flex',
  width: '25%',
  [theme.breakpoints.down(722)]: {
    marginRight: 'unset',
    marginBottom: '16px',
    width: '100%',
  },
}));

export const LanguageBox = styled(Box)(({ theme }) => ({
  marginRight: '16px',
  width: '10%',
  [theme.breakpoints.down(722)]: {
    marginRight: 'unset',
    marginBottom: '16px',
    width: '100%',
  },
}));

export const PersonalInfoSmallBoxWithNoMarginRight = styled(Box)(({ theme }) => ({
  marginLeft: '16px',
  [theme.breakpoints.down(722)]: {
    marginLeft: 'unset',
    marginBottom: '16px',
    width: '100%',
  },
}));

export const AccountWithMarginLeftBox = styled(Box)(({ theme }) => ({
  marginLeft: '16px',
  [theme.breakpoints.down(722)]: {
    marginLeft: 'unset',
    marginBottom: '16px',
    width: '100%',
  },
}));

export const ExpirationDateBox = styled(Box)(({ theme }) => ({
  width: '30%',
  [theme.breakpoints.down(722)]: {
    width: '100%',
  },
}));

export const AccountWithMarginRightBox = styled(Box)(({ theme }) => ({
  marginRight: '16px',
  width: '33.3%',
  [theme.breakpoints.down(722)]: {
    marginRight: 'unset',
    marginBottom: '16px',
    width: '100%',
  },
}));

export const TabsContainerContractsListView = styled(Tabs)(() => ({
  '.MuiTabs-flexContainer': {
    justifyContent: 'start',
  },
}));

export const SmallBoxWithNoMargin = styled(Box)(({ theme }) => ({
  width: '25%',
  [theme.breakpoints.down(722)]: {
    marginBottom: '16px',
    width: '100%',
  },
}));

export const RowContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  [theme.breakpoints.down(722)]: {
    flexDirection: 'column',
    marginTop: '24px',
  },
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  display: 'block',
  color: theme.palette.secondary.contrastText,
  fontWeight: 600,
  fontSize: 14,
  textAlign: 'left',
}));

export const ContentContainer = styled(Box)<{ disableScroll?: boolean }>(({ theme, disableScroll = true }) => ({
  overflowY: disableScroll ? 'hidden' : 'scroll',
  background: 'rgb(250, 250, 250)',
  display: 'flex',
  flexDirection: 'column',
  height: '480px',
  padding: '32px',
  gap: '32px',
  [theme.breakpoints.down(722)]: {
    height: '470px',
  },
}));

export const ErrorText = styled(UPInputLabel)(({ theme }) => ({
  '&.MuiFormLabel-colorPrimary': {
    color: theme.palette.error.main,
  },
}));

export const InfoText = styled(UPInputLabel)(({ theme }) => ({
  '&.MuiFormLabel-colorPrimary': {
    color: theme.palette.primary.main,
  },
}));

export const EmployeeExistsText = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  color: theme.palette.primary.main,
  marginTop: '16px',
}));

export const ModalCloseIcon = styled(Box)(() => ({
  position: 'absolute',
  right: 32,
  top: 32,
  width: 24,
  height: 24,
  cursor: 'pointer',
}));

export const StayAddressCheckboxStyled = styled(Box)(({ theme }) => ({
  marginTop: '45px',
  marginLeft: '50px',
  [theme.breakpoints.down(722)]: {
    marginLeft: 'unset',
    marginTop: '20px',
  },
}));

export const IPBackground = styled(Box)(({ theme }) => ({
  position: 'absolute',
  width: '100%',
  height: '100vh',
  background: `url(${Background})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'contain',
  zIndex: '-1',
  backgroundPosition: 'bottom',
  backgroundPositionX: '0',
  [theme.breakpoints.down(800)]: {
    background: `url(${BackgroundMobile})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'bottom',
    backgroundPositionX: '0',
  },
}));

export const IPContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  marginTop: '90px',
}));

export const IPTitle = styled(Typography)(({ theme }) => ({
  fontSize: 24,
  fontWeight: 600,
  fontFamily: theme.typography.fontFamily,
  color: theme.palette.primary.main,
  padding: '0 55px',
  textAlign: 'center',
}));

export const IPSalesPitch = styled(Typography)(({ theme }) => ({
  fontSize: 16,
  fontWeight: 400,
  fontFamily: theme.typography.fontFamily,
  color: theme.palette.secondary.contrastText,
  textAlign: 'center',
  marginTop: '35px',
}));

export const IPButton = styled(UPButton)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  width: '290px',
  marginTop: '60px',
}));

export const IPLinkToOnboarding = styled(Link)(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.secondary.contrastText,
  fontFamily: theme.typography.fontFamily,
  textDecoration: 'underline',
  textDecorationColor: theme.palette.secondary.contrastText,
  '&:hover': {
    color: theme.palette.primary.main,
    textDecorationColor: theme.palette.primary.main,
    cursor: 'pointer',
  },
}));

export const PictureAgreementLink = styled('a')(({ theme }) => ({
  color: theme.palette.secondary.contrastText,
  fontFamily: theme.typography.fontFamily,
  textDecoration: 'underline',
  textDecorationColor: theme.palette.secondary.contrastText,
  '&:hover': {
    color: theme.palette.primary.main,
    textDecorationColor: theme.palette.primary.main,
  },
}));

export const OLContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '16px',
  flexDirection: 'column',
  width: '50%',
  [theme.breakpoints.down(722)]: {
    width: '100%',
  },
}));

export const OLTitle = styled(Typography)(({ theme }) => ({
  marginBottom: '16px',
  color: theme.palette.primary.main,
  fontWeight: 600,
  fontSize: 20,
  textAlign: 'center',
}));

export const OLSubtitle = styled(Typography)(({ theme }) => ({
  marginBottom: '16px',
  color: theme.palette.secondary.contrastText,
  fontWeight: 400,
  fontSize: 18,
  textAlign: 'center',
}));

export const OLContentContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '480px',
  padding: '32px',
  [theme.breakpoints.down(722)]: {
    height: '470px',
  },
}));
export const OLModalContainer = styled(Box)(() => ({
  width: '100%',
  borderRadius: '8px',
  border: 'none',
  height: '500px',
  position: 'relative',
}));

export const SubsectionTitleContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  marginTop: '16px',
  marginBottom: '8px',
}));

export const SubsectionTitle = styled(Typography)(({ theme }) => ({
  display: 'block',
  color: theme.palette.secondary.contrastText,
  fontWeight: 500,
  fontSize: 14,
  lineHeight: '20px',
  textAlign: 'left',
}));

export const SubsectionInputContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  marginLeft: '16px',
  gap: '16px',
  [theme.breakpoints.down(722)]: {
    flexDirection: 'column',
    margin: '0px',
    width: '100%',
    gap: '0px',
  },
}));

export const SubsectionErrorContainer = styled(Box)(({ theme }) => ({
  marginLeft: '16px',
  marginTop: '8px',
  [theme.breakpoints.down(722)]: {
    marginTop: '8px',
    marginLeft: '0px',
  },
}));

export const SubsectionDateContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
}));

export const SecuritySubsectionContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
}));
